import { render, staticRenderFns } from "./profile-staff.vue?vue&type=template&id=b716e2e6&"
import script from "./profile-staff.vue?vue&type=script&lang=js&"
export * from "./profile-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports